export default __webpack_public_path__ + "static/media/relaunch.7856f1cf.png";